import isEmpty from 'lodash-es/isEmpty'
import mapKeys from 'lodash-es/mapKeys'

import { SERVER_NON_FIELD_ERROR_KEY } from '../../../../../../constants/validation'
import {
  getListingFlatPublishedListingTitle,
  getListingServerFieldErrors,
  LISTING_FLAT_ALREADY_PUBLISHED_ERROR_CODE,
  LISTING_FORM_FIELD_NAME_FLAT,
  LISTING_PUBLICATION_IN_PROGRESS_ERROR_CODE,
  LISTING_PUBLICATION_IN_PROGRESS_ERROR_KEY,
} from '../../../../../RentalPortalListing'
import {
  LISTING_FORM_FIELD_NAME_TIMING,
  LISTING_FORM_TIMING,
} from '../../RentalPortalListingsForm.constants'
import { getHasListingPublishSection } from '../../RentalPortalListingsForm.utils'

import { LISTING_FORM_SERVER_FIELD_NAME } from './useRentalPortalListingsFormSubmit.constants'

function getListingFormServerFieldErrors({ error, t }) {
  return mapKeys(
    getListingServerFieldErrors({ error, t }),
    (message, field) => LISTING_FORM_SERVER_FIELD_NAME[field] ?? field
  )
}

function getListingFormSaveErrors({ error, t }) {
  const fieldErrors = getListingFormServerFieldErrors({ error, t })

  switch (error?.response?.data?.errors) {
    case LISTING_FLAT_ALREADY_PUBLISHED_ERROR_CODE:
      return {
        [LISTING_FORM_FIELD_NAME_FLAT]: t(
          'RentalPortal.ListingFormFlatHasPublishedErrorKey',
          {
            title: getListingFlatPublishedListingTitle({
              flatPublishedListing: error.response.data.meta?.listing,
              t,
            }),
          }
        ),
      }
    case LISTING_PUBLICATION_IN_PROGRESS_ERROR_CODE:
      return {
        [SERVER_NON_FIELD_ERROR_KEY]: t(
          LISTING_PUBLICATION_IN_PROGRESS_ERROR_KEY
        ),
      }
    default:
      return isEmpty(fieldErrors)
        ? {
            [SERVER_NON_FIELD_ERROR_KEY]: t(
              'RentalPortal.ListingFormSaveErrorKey'
            ),
          }
        : fieldErrors
  }
}

export function setListingFormSaveError({
  error,
  setErrors,
  setSubmitting,
  t,
}) {
  setSubmitting(false)

  setErrors(getListingFormSaveErrors({ error, t }))
}

export function getListingFormSuccessTiming({ listingId, values }) {
  return getHasListingPublishSection({ listingId })
    ? values[LISTING_FORM_FIELD_NAME_TIMING]
    : LISTING_FORM_TIMING.draft
}
